import Api from './api'

export default {
    history() {
        return Api()
            .post('/api/history', null, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => response.data)
    },
    historyCategory(category) {
        return Api()
            .post('/api/history/' + category, null, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((response) => response.data)
    },
}